const SELLER_PAYOUT_ROUTES = {
  GET_SELLER_PAYOUT: "seller-payout/list",
  UPDATE_SELLER_PAYOUT: "seller-payout/create",
  GET_SELLER_PAYOUT_HISTORY: "seller-payout/history",
  CHECK_PAYOUT_STATUS: "seller-payout/status",
  UPDATE_BANK_DETAILS: "seller-payout/bank-details",
  GET_SELLER_LEDGER: "seller-payout/ledger",
};

export default SELLER_PAYOUT_ROUTES;
